import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToolSearchParams } from 'src/app/shared/models/toolSearchParams';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';

@Component({
  selector: 'app-autocomplete-dropdown',
  templateUrl: './autocomplete-dropdown.component.html',
  styleUrls: ['./autocomplete-dropdown.component.scss'],
})
export class AutocompleteDropdownComponent {
  searchParams: ToolSearchParams = {
    page: 1,
    limit: 50,
    embed: 'potentialJobDetail',
    attributes: 'id,jobNumber,name',
  };

  @Input() selectedItems: any = [];
  @Input() dropdownPosition: string;
  @Input() inputItems: any;
  @Input() label: string;
  @Input() dropdownType: 'flat' | 'multiple' | 'single';
  @Input() model: string;
  @Input() propertyName: string;
  @Input() type: string;
  @Input() bindVal: string = 'id';
  @Input() bindLabel: string;
  @Output() loadOptions: EventEmitter<any> = new EventEmitter<any>();
  @Output() filter: EventEmitter<any> = new EventEmitter<Array<Number>>();

  constructor(private localStorageService: LocalstorageService) { }

  ngOnInit(): void {
    if (this.type === 'foremanSelection' && this.selectedItems?.length) {
      this.selectedItems = this.selectedItems.split(',').map(item => item);

      this.label = this.inputItems
        .filter(item => this.selectedItems.includes(item[this.bindVal]))
        .map(item => item[this.bindLabel])
        .join(', ');
    }

    // If on an employees page and the input is for employee status.
    if (this.type === 'employeeFilter' && this.label?.toLowerCase().includes('status')) {
      const selectedItemsByDefault = this.inputItems.filter(el => el?.selectedByDefault) ?? [];

      this.selectedItems = selectedItemsByDefault.map(el => el.id);
    }

     if (this.type === 'jobBoardEmployeesFilter' && this.label?.toLowerCase().includes('status')) {
      const selectedItemsByDefault = this.inputItems.filter(el => el?.selectedByDefault) ?? [];

      this.selectedItems = selectedItemsByDefault.map(el => el.id);
    }

    if (this.type === 'toolFilter' && this.label?.toLowerCase().includes('status')) {
      const selectedItemsByDefault = this.inputItems.filter(el => el?.selectedByDefault) ?? [];

      this.selectedItems = selectedItemsByDefault.map(el => el.name);
    }
  }

  changeFn() {
    if (this.type === 'foremanSelection') {
      this.label = this.inputItems
        .filter(item => this.selectedItems.includes(item[this.bindVal]))
        .map(item => item[this.bindLabel])
        .join(', ');
    }
    if (this.selectedItems?.[`${this.bindLabel}PropertyType`] || this.selectedItems?.[this.bindVal]) {
      const filterData = {
        value: this.selectedItems[this.bindVal],
        propertyType: this.selectedItems[`${this.bindLabel}PropertyType`],
      };
      this.filter.emit(filterData);
      return;
    }

    this.filter.emit(this.selectedItems);
  }

  getBindLabel() {
    return this.bindLabel;
  }

  ngOnChanges() {
    if (this.type !== 'foremanSelection') this.mapFilters();
    if (this.model === 'assignment_types') this.bindVal = 'name';
  }

  mapFilters() {
    if (this.type === 'toolFilter') {
      const toolFilter = JSON.parse(this.localStorageService.getItem('toolFilter'));
      this.selectedItems =
        toolFilter && toolFilter[this.propertyName]
          ? this.dropdownType === 'single'
            ? toolFilter[this.propertyName]
            : toolFilter[this.propertyName].split(',')
          : [];
    } else if (this.type === 'modelFilter') {
      const toolFilter = JSON.parse(this.localStorageService.getItem('modelFilter'));
      this.selectedItems =
        toolFilter && toolFilter[this.propertyName]
          ? this.dropdownType === 'single'
            ? toolFilter[this.propertyName]
            : toolFilter[this.propertyName].split(',')
          : [];
    } else if (this.type === 'employeeFilter') {
      const employeeFilter = JSON.parse(this.localStorageService.getItem('employeeFilter'));
      this.selectedItems =
        employeeFilter && employeeFilter[this.propertyName]
          ? this.dropdownType === 'single'
            ? employeeFilter[this.propertyName]
            : employeeFilter[this.propertyName].split(',')
          : [];
    } else if (this.type === 'manageJobsFilter') {
      const manageJobsFilter = JSON.parse(this.localStorageService.getItem('manageJobsFilter'));
      this.selectedItems =
        manageJobsFilter && manageJobsFilter[this.propertyName]
          ? this.dropdownType === 'single'
            ? manageJobsFilter[this.propertyName]
            : manageJobsFilter[this.propertyName].split(',')
          : [];
    } else if (this.type === 'jobBoardEmployeesFilter') {
      const jobBoardEmployeesFilter = JSON.parse(this.localStorageService.getItem('jobBoardEmployeesFilter'));
      this.selectedItems =
        jobBoardEmployeesFilter && jobBoardEmployeesFilter[this.propertyName]
          ? this.dropdownType === 'single'
            ? jobBoardEmployeesFilter[this.propertyName]
            : jobBoardEmployeesFilter[this.propertyName].split(',')
          : [];
      
      if ((!jobBoardEmployeesFilter || !jobBoardEmployeesFilter[this.propertyName]) && 
          this.label?.toLowerCase().includes('status')) {
        const selectedItemsByDefault = this.inputItems.filter(el => el?.selectedByDefault) ?? [];
        this.selectedItems = selectedItemsByDefault.map(el => el.id);
      }
    } else if (this.type === 'jobBoardFilter') {
      const jobBoardFilter = JSON.parse(this.localStorageService.getItem('jobBoardFilter'));
      this.selectedItems =
        jobBoardFilter && jobBoardFilter[this.propertyName]
          ? this.dropdownType === 'single'
            ? jobBoardFilter[this.propertyName]
            : jobBoardFilter[this.propertyName].split(',')
          : [];
    } else {
      const toolFilter = JSON.parse(this.localStorageService.getItem('transferFilter'));
      this.selectedItems =
        toolFilter && toolFilter[this.propertyName]
          ? this.dropdownType === 'single'
            ? toolFilter[this.propertyName]
            : toolFilter[this.propertyName].split(',')
          : [];
    }
  }

  getVirtualScroll(): boolean {
    return this.inputItems?.length > 100;
  }

  getData() {
    this.mapFilters();
    if (this.model !== 'enabled') {
      this.loadOptions.emit();
    }
  }

  reloadOptions() {
    this.loadOptions.emit();
  }

  clearFilter() {
    this.selectedItems = [];
    this.getData();
  }

  searchProd(event) {
    this.searchParams = { ...this.searchParams, search: event.term };
    this.getData();
  }

  openDropdown(event) { }
}
